/**
 * Uses string data if exists, else returns empty string.
 * Syntax sugar for stringValue || ''.
 */
export const stringData = (value: string | null | undefined): string => value || '';
/**
 * Formats document object to return document or undefined.
 */
